import {
    LOGIN_USER_PENDING,
    LOGIN_USER_FULFILLED,
    LOGIN_USER_FAILED,
    LOGOUT_USER_FAILED,
    LOGOUT_USER_FULFILLED,
    LOGOUT_USER_PENDING
} from '../Actions/UserActions';


// INITIALIZE STATE

const initialState = {
    user: {},
    loggedIn: false,
    loggingIn: false,
    loggingOut: false,
    message: '',
    failed: false,
};


// REDUCER

export const UserReducer = (state = initialState, action) => {
    
    let newState = Object.assign({}, state);

    switch(action.type) {
        case LOGIN_USER_PENDING:
            return {
                ...state,
                loggingIn: true,
                loggedIn: false,
                failed: false,
                message: '',
            };
        case LOGIN_USER_FULFILLED:
            return {
                ...state,
                user: action.payload,
                loggedIn: true,
                loggingIn: false,
                failed: false,
                message: '',
            };
        case LOGIN_USER_FAILED:
            return {
                ...state,
                loggedIn: false,
                loggingIn: false,
                failed: true,
                message: action.payload.message,
            };
        case LOGOUT_USER_PENDING:
            return {
                ...state,
                loggingOut: true,
                failed: false,
                message: '',
            };
        case LOGOUT_USER_FULFILLED:
            return {
                ...state,
                user: {},
                loggingOut: false,
                loggedIn: false,
                failed: false,
                message: '',
            };
        case LOGOUT_USER_FAILED:
            return {
                ...state,
                loggingOut: false,
                message: action.payload.message,
                failed: true,
            };
        default:
            return state;
    }
};